module.exports = __webpack_public_path__ + "img/3.5e1bb6a4.png";